<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" @mask="showMask" ref="tableRef" tableId="DcCosRegisterLinksRecord">
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="手机号/邮箱">
              <a-input v-model:value="queryForm.contactInfo" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="发送人">
              <UserSelect v-model:value="queryForm.operator" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item label="发送时间">
              <cos-range-picker v-model:startTime="queryForm.start" v-model:endTime="queryForm.end" />
            </dc-form-item>
            <dc-form-item label="类型">
              <a-select ref="select" v-model:value="queryForm.type" allowClear placeholder="请选择">
                <a-select-option value="">全部</a-select-option>
                <a-select-option :value="1">短信</a-select-option>
                <a-select-option :value="0">邮箱</a-select-option>
              </a-select>
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'type'">
            {{ ['邮件', '短信'][record.type] }}
          </template>
          <template v-if="column.dataIndex === 'result'">
            {{ ['处理中', '成功', '失败'][record.result] }}
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import { reactive, ref, computed } from 'vue'
import { registerRecordPage, getRegisterDetail } from '@/api/gucangSales/businessRuleSetting'

export default { name: 'DcCosFbuRegisterLinksRecord' }
</script>
<script setup lang="ts">
const tableRef = ref()
const queryForm = reactive({
  customerName: '',
  contactInfo: '',
  start: '',
  end: '',
  type: undefined
})
// 获取详情联系人信息
const showMask = (record: any, callBack: (res: any) => void) => {
  getRegisterDetail(record.id).then((res) => {
    const { contactInfo } = res.data
    callBack({ contactInfo })
  })
}
// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await registerRecordPage({ ...params })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '类型', dataIndex: 'type' },
  {
    title: '手机/邮件',
    dataIndex: 'contactInfo',
    cosType: 'mask'
  },
  { title: '发送人', dataIndex: 'operatorName' },
  { title: '发送时间', dataIndex: 'createTime' },
  { title: '结果', dataIndex: 'result' }
])
</script>

<style scoped></style>
